var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlog2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 552,
    height: 276,
    viewBox: "0 0 552 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 552,
    height: 276,
    rx: 16,
    fill: "#180A3A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 212,
    y: 74,
    width: 128,
    height: 128,
    rx: 64,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M262 112.667C263.488 112.667 264.962 112.96 266.337 113.529C267.712 114.099 268.961 114.934 270.014 115.986C271.066 117.038 271.901 118.288 272.47 119.663C273.04 121.038 273.333 122.512 273.333 124V135.333H262C258.994 135.333 256.111 134.139 253.986 132.014C251.861 129.888 250.667 127.006 250.667 124C250.667 120.994 251.861 118.111 253.986 115.986C256.111 113.861 258.994 112.667 262 112.667ZM262 140.667H273.333V152C273.333 154.241 272.668 156.433 271.423 158.296C270.178 160.16 268.408 161.613 266.337 162.471C264.266 163.328 261.987 163.553 259.789 163.116C257.59 162.678 255.571 161.599 253.986 160.014C252.401 158.429 251.322 156.409 250.884 154.211C250.447 152.013 250.671 149.734 251.529 147.663C252.387 145.592 253.84 143.822 255.703 142.577C257.567 141.331 259.758 140.667 262 140.667ZM290 112.667C293.006 112.667 295.888 113.861 298.014 115.986C300.139 118.111 301.333 120.994 301.333 124C301.333 127.006 300.139 129.888 298.014 132.014C295.888 134.139 293.006 135.333 290 135.333H278.667V124C278.667 120.994 279.861 118.111 281.986 115.986C284.111 113.861 286.994 112.667 290 112.667ZM278.667 140.667H290C292.241 140.667 294.433 141.331 296.296 142.577C298.16 143.822 299.613 145.592 300.47 147.663C301.328 149.734 301.553 152.013 301.115 154.211C300.678 156.409 299.599 158.429 298.014 160.014C296.429 161.599 294.409 162.678 292.211 163.116C290.012 163.553 287.734 163.328 285.663 162.471C283.592 161.613 281.822 160.16 280.577 158.296C279.331 156.433 278.667 154.241 278.667 152V140.667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog2);
export default __webpack_public_path__ + "static/media/blog2.f5937735331fd24595044c2ae54b28a0.svg";
export { ForwardRef as ReactComponent };